import { Fade } from "react-awesome-reveal";
import IconDescription from "../../../../components/ui/icon-description/icon-description";
import "./poles-product.scss";

const PolesProduct = () => {
  return (
    <section className="poles-product">
      <div className="poles-product__title-container">
        <Fade direction="up" duration={700} triggerOnce>
          <h2 className="poles-product__title">Il Prodotto</h2>
          <div className="poles-product__title-divider" />
        </Fade>
      </div>

      <div className="poles-product__text-container">
        <Fade direction="up" delay={150} duration={800} triggerOnce>
          <p className="poles-product__text">
            Eseguiamo la costruzione in opera di pali rotoinfissi ad alta
            resistenza laterale e di punta, muniti di fondello a perdere
            brevettato a tenuta idraulica e punta in acciaio, di diametro minimo
            15 cm e diametro massimo 40 cm, con vibrazioni minime e senza
            asportazione di materiale di risulta.
          </p>
          <p className="poles-product__text">
            I pali "rotoinfissi" sono realizzati in c.a. gettato con armatura,
            lunghezza e ad un interasse adeguato.
          </p>
        </Fade>
      </div>

      <div className="poles-product__icons-list">
        <Fade
          cascade
          direction="up"
          delay={300}
          duration={900}
          damping={0.2}
          triggerOnce
        >
          <div className="poles-product__icon-element">
            <IconDescription
              icon={"ruler"}
              title={"Diametro"}
              text={"Da 15 cm a 40 cm"}
              type={"primary"}
              size={"big"}
              direction={"vertical"}
            />
          </div>
          <div className="poles-product__icon-element">
            <IconDescription
              icon={"cube"}
              title={"Materiale"}
              text={"C.A. gettato in opera"}
              type={"secondary"}
              size={"big"}
              direction={"vertical"}
            />
          </div>
          <div className="poles-product__icon-element">
            <IconDescription
              icon={"hand-back"}
              title={"Resistenza"}
              text={"Alta resistenza laterale e di punta"}
              type={"secondary"}
              size={"big"}
              direction={"vertical"}
            />
          </div>
        </Fade>
      </div>
    </section>
  );
};

export default PolesProduct;
